import { FieldInstance } from "db/definitions";
import { buildFieldInstance, bulkRetrieveFieldInstances } from "db/queries/fieldInstanceQueries";

/**
 * Given the ids, we retrieve the fieldInstances offline, then assemble them by grabbing the necessary fieldTemplate/options, altInstace,
 * tableFields, and image data
 * @author Eric Webb <ewebb@factorearth.com>
 * @param ids The ids of the fields we want to copy
 * @returns The built out fieldInstances for us to copy
 */
export async function getFieldsForDuplication(ids: string[]): Promise<FieldInstance[]> {
	const fieldPromises = [];
	const fields = await bulkRetrieveFieldInstances(ids);
	for (const field of fields) {
		if (field) fieldPromises.push(buildFieldInstance(field));
	}
	const finalFields = await Promise.all(fieldPromises);
	return finalFields;
}
